/**
 * Converts Blob to File
 * This is usefull for:
 *   - Preserving Files that actually has a filename
 *   - Autocomplete the filename for blobs according to its mimetype
 *
 *
 * @collboard-modules-sdk
 */
export async function blobToFile(blob: File | Blob): Promise<File> {
    if (blob instanceof File) {
        return blob;
    }

    return new File(
        [blob],
        'untitled' /* <- TODO: Add propper extension and name according to its mimetype like document.pdf, image.jpg,... */,
        { type: blob.type },
    );
}
